module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout__drawer mdl-color--grey-50 mdl-color-text--grey-800"
  }, [_c('header', {
    staticClass: "drawer-header bg-green"
  }, [_c('img', {
    staticClass: "drawer-avatar",
    attrs: {
      "src": _vm.$user.data.avatar || './profile-64.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "drawer-avatar-dropdown"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$user.data.email))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$user.data.role.toUpperCase()))]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])]), _vm._v(" "), _c('nav', {
    staticClass: "drawer-navigation mdl-navigation mdl-color--grey-50 mdl-color-text--grey-800"
  }, [_vm._l((_vm.links), function(link) {
    return _c('router-link', {
      key: link.to,
      attrs: {
        "to": link.to
      }
    }, [_c('a', {
      staticClass: "mdl-navigation__link",
      on: {
        "click": _vm.toggleDrawer
      }
    }, [_c('i', {
      staticClass: "material-icons",
      attrs: {
        "role": "presentation"
      }
    }, [_vm._v(_vm._s(link.icon))]), _vm._v("\n        " + _vm._s(link.name) + "\n      ")])])
  }), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Cerrar Sesión")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76b96c9b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Drawer/index.vue
// module id = 240
// module chunks = 0